import React, { useMemo } from 'react';

import { observer } from 'mobx-react';

import { LbPagination } from '@infoods/lifebase-ui';

import classes from './PaymentIssueTable.module.scss';
import { TitleRow } from './TitleRow/TitleRow';
import { PaymentIssueRow } from './PaymentIssueRow/PaymentIssueRow';
import { EmptyList } from '../../../../shared/components/ui-components';
import { paymentIssueStore } from '../../../stores/paymentIssueStore';
import {
  COLUMN_WIDTHS,
  PAYMENT_ISSUE_COLUMN,
  PAYMENT_ISSUE_TABLE_MODE,
  PaymentIssueTableMode,
  ShowColumnsConfig,
} from './PaymentIssueTable.settings';
import { getVisibleColumns } from '../../../../shared/components/table-components';
import { loggedInUserDataStore } from '../../../../shared/stores/loggedInUserDataStore';

type PaymentIssueTableProps = {
  tableMode: PaymentIssueTableMode;
};

const PaymentIssueTable = observer(({ tableMode }: PaymentIssueTableProps) => {
  const { isCoach } = loggedInUserDataStore;
  const { paymentIssues, filterMethods } = paymentIssueStore;
  const { isShowPlaceholder, totalElements, elementsPerPage, getPaginationProps } =
    filterMethods;

  const showColumnsConfig = useMemo<ShowColumnsConfig>(
    () => ({
      [PAYMENT_ISSUE_COLUMN.NAME]: true,
      [PAYMENT_ISSUE_COLUMN.SOLUTION]: tableMode === PAYMENT_ISSUE_TABLE_MODE.ALL,
      [PAYMENT_ISSUE_COLUMN.COACH]:
        !isCoach &&
        (tableMode === PAYMENT_ISSUE_TABLE_MODE.NUTRITION ||
          tableMode === PAYMENT_ISSUE_TABLE_MODE.ALL),
      [PAYMENT_ISSUE_COLUMN.SUBSCRIPTION]: true,
      [PAYMENT_ISSUE_COLUMN.PRICE]: true,
      [PAYMENT_ISSUE_COLUMN.ACTIVE_SINCE]: true,
      [PAYMENT_ISSUE_COLUMN.DATE_OF_UPDATE]: true,
    }),
    [tableMode, isCoach],
  );

  const { visibleColumns, gridTemplateColumns } = getVisibleColumns({
    columnEnum: PAYMENT_ISSUE_COLUMN,
    showColumnsConfig,
    columnWidths: COLUMN_WIDTHS,
  });

  return (
    <>
      <div className={classes.paymentIssueTable} style={{ gridTemplateColumns }}>
        <TitleRow visibleColumns={visibleColumns} />
        {paymentIssues.map((issue) => {
          //We need to combine user id and solution type to avoid duplicate keys on dashboard mixed-solution table
          const key = issue.id + issue.solutionType;
          return (
            <PaymentIssueRow
              key={key}
              paymentIssue={issue}
              visibleColumns={visibleColumns}
            />
          );
        })}
      </div>
      <EmptyList
        show={isShowPlaceholder}
        description="There are no payment issues"
        size="small"
      />
      <LbPagination
        totalElements={totalElements}
        elementsPerPage={elementsPerPage}
        variant="inBox"
        {...getPaginationProps()}
      />
    </>
  );
});

export { PaymentIssueTable };
